const { REACT_APP_URL, NODE_ENV } = process.env
let URL = "https://kothar-api-g2g0h2cmh7dvcma4.uaenorth-01.azurewebsites.net/v2";
if (NODE_ENV === "development") {
    URL = "http://localhost:3000/v2";
}
if (REACT_APP_URL === "dev") {
    URL = "https://kothar-api-g2g0h2cmh7dvcma4.uaenorth-01.azurewebsites.net/v2";
    // URL = "http://localhost:3000/v2";
}
const BASE_URL = URL
export { BASE_URL };
